import type { SvgIconProps } from "@mui/material";

import {
  CandidatesIcon,
  GemdTableIcon,
  PredictorIcon,
  SearchSpaceIcon,
} from "@citrine/atoms/icons";
import type { TranslationID } from "@citrine/lang/utils";
import type { BranchNodeType } from "@citrine/resources/branch";

export const TITLE_IDS: Record<BranchNodeType, TranslationID> = {
  data: "node.training-set",
  design: "node.design-space",
  candidate: "node.candidates",
  predictor: "node.predictor",
};

const getNodeIcon = (type: BranchNodeType) => {
  switch (type) {
    case "data":
      return GemdTableIcon;
    case "predictor":
      return PredictorIcon;
    case "design":
      return SearchSpaceIcon;
    case "candidate":
      return CandidatesIcon;
  }
};

export function NodeIcon({
  type,
  ...props
}: { type: BranchNodeType } & Pick<SvgIconProps, "className" | "fontSize">) {
  const Icon = getNodeIcon(type);

  return <Icon {...props} />;
}
